import * as React from "react";
import { getImage, getSrc, getSrcSet } from "gatsby-plugin-image";
import { ImageContentCardData } from "types/image-content-card-data";
import { ReactComponent as CaretRight } from "img/arrows/caret-right.svg";

const ImageContentCardLight: React.FC<ImageContentCardData> = ({ columns, cardImage, cardImageAlt = '', headline, subtext, buttonText, buttonUrl, buttonUrlTarget = '_self' }) => {

    const cardImageData = getImage(cardImage || null);

    const cardImgSrc = cardImageData ? getSrc(cardImageData) : '/img/placeholder/image-content-card.jpg';

    const cardImgSrcSet = cardImageData ? getSrcSet(cardImageData) : '/img/placeholder/image-content-card.jpg 1x, /img/placeholder/image-content-card@2x.jpg 2x';

    const headlineSize = columns == 2 ? 'h3' : 'h4';

    return (
        <div>
            <div className="image-content-card-light">
                <div className="image-content-card-light__image">
                    {cardImage && <img src={cardImgSrc} srcSet={cardImgSrcSet} alt={cardImageAlt} width={cardImageData?.width} height={cardImageData?.height} />}
                </div>
                <div className="image-content-card-light__content">
                    {/** TODO: Vulnerability warning for `buttonUrl`. client-side-unvalidated-url-redirection Allowing unvalidated redirection based on user-specified URLs  */}
                    <h3 className={`card-headline ${headlineSize}`}><a href={buttonUrl} target={buttonUrlTarget}>{headline}</a></h3>
                    <div className="card-subtext rtecontent" dangerouslySetInnerHTML={{ __html: subtext || "" }}></div>
                    <a className="card-button btn-text-caret" href={buttonUrl} target={buttonUrlTarget}><span>{buttonText}</span><CaretRight /></a>
                </div>
            </div>
        </div>
    );
};

export default ImageContentCardLight;